/* eslint-disable react-hooks/exhaustive-deps */
import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import {useState, useEffect, useRef} from 'react'
import "react-datepicker/dist/react-datepicker.css";
import calendar from '../../assets/calendar.svg'
import makanan1 from '../../assets/makanan1.png'
import { useNavigate } from "react-router-dom";
import circleback from '../../assets/circleback.svg'
import down from '../../assets/down.svg'
import time from '../../assets/time.svg'
import user from '../../assets/user.svg'
import plus from '../../assets/plus.svg'
import minus from '../../assets/minus.svg'
import foto1 from '../../assets/foto4.png'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { PageLogin } from '../LoginPage/PageLogin'
import { CSSTransition } from 'react-transition-group';
import spinner from '../../assets/spinner.gif'
import axios from 'axios';
import { baseUrl } from '../../lib/api';

export const PageSetSchedule = () => {
    const [detail,setDetail] = useState()
    const [guest, setGuest] = useState(1)
    const history = useNavigate()
    const [total, setTotal] = useState(0)
    const [showCalendar, setShowCalendar] = useState(false)
    const [showClock, setShowClock] = useState(false)
    const [selectedDate, setSelectedDate] = useState()
    const [dateShown, setDateShown] = useState('Select date')
    const [clockSelected, setClockSelected] = useState('Select time')
    const [showStyle, setShowStyle] = useState(false)
    const [style, setStyle] = useState('Select serving style')
    const [showLogin, setShowLogin] = useState(false)
    const [specialRequest, setSpecialRequest] = useState('')
    const [val1, setval1] = useState(false)
    const [val2, setval2] = useState(false)
    const [val3, setval3] = useState(false)
    const [loading, setLoading] = useState(true)
    const firstUpdate2 = useRef(true);
    const firstUpdate = useRef(true);
    const firstUpdate3 = useRef(true);
    const firstUpdate4= useRef(true);
    const firstUpdate5 = useRef(true);
    const [showNavPopup, setShowNavPopup] = useState(false)

    const handleCloseAll = () => {
        setShowCalendar(false)
        setShowNavPopup(false)
        setShowClock(false)
        setShowLogin(false)
        setShowStyle(false)
    }

    const handleSelectDate = (e) => {
        setSelectedDate(e)
        var elem = document.getElementById("PSSdateshown");
        elem.className = "tiny normal PSSpertanyaantext black"
        setDateShown(`${e.getFullYear()}-${formatDate(e.getMonth()+1)}-${formatDate(e.getDate())}`)
        setShowCalendar(false)
    }

    const handleClockSelect = (e) => {
        setClockSelected(e)
        var elem = document.getElementById("PSSclockshown");
        elem.className = "tiny normal PSSpertanyaantext black"
        setShowClock(false)
    }

    const handleSelectStyle = (e) => {
        setStyle(e)
        var elem = document.getElementById("PSSstyleshown");
        elem.className = "tiny normal PSSpertanyaantext black"
        setShowStyle(false)
    }

    const formatDate = (data) =>{
        if(data<10){
          return `0${data}`
        }else{
          return data
        }
    }

    const handleGuest = (e) => {
        var elem = document.getElementById("PSSguestshown");
        elem.className = "tiny normal PSSpertanyaantext black"
        if(e === "minus"){
            if(guest === 1){
                return
            }else{
                setGuest(guest-1)
            }
        }else{
            if(guest === detail.pricelist[detail.pricelist.length-1].max){
                return
            }else{
                setGuest(guest+1)
            }
        }
    }

    useEffect(() =>{
        window.scrollTo(0, 0)
        setLoading(true)
        const menuDetailPriceFromDB = async () => {
            try {
                const data = await callApigetMenuDetailPrice()
                // Create parser before set to state
                // setDetail(data)
            } catch (error) {
                console.log("Error menuDetailPriceFromDB")
            }
        }
        // Turn on to use it
        // menuDetailPriceFromDB("finish")
        console.log(detail)
        setDetail({chef:"Fauzan Pradana",foto:foto1, jenis:"Asian",fotoMakanan:makanan1,menu:["Beef bulgogi", "Yaki gyoza"],pricelist:[{min:1,max:4,harga:200},{min:5,max:6,harga:150}], jam:["18:00 - 19:00","19:00 - 20:00", "20:00 - 21:00"] })
        localStorage.setItem('TaplakBookingDetail',JSON.stringify(detail))
        localStorage.setItem('nav', 'fnd')
    },[])

    useEffect(() => {
        console.log("masuk sini kok")
        console.log(detail)
        if (firstUpdate2.current) {
            firstUpdate2.current = false;
        }else{
            setLoading(false)
            console.log("selesai")
            console.log(detail)
            setTotal(detail.pricelist[0].harga*1000)
        }
    },[detail])

    useEffect(()=>{
        if (firstUpdate.current) {
            firstUpdate.current = false;
        }else{
            var elem = document.getElementById("PSSdate");
            var elem2 = document.getElementById("PSSdatedown");
            elem2.style.transition = "transform 0.5s"
            if(showCalendar===true){
                elem.className = "PSSpertanyaan flex PSSyellow";
                elem2.style.transform = "rotate(180deg)"
            }else{
                elem.className = "PSSpertanyaan flex";
                elem2.style.transform = "rotate(0)"
            }
        }
    },[showCalendar])

    useEffect(()=>{
        if (firstUpdate3.current) {
            firstUpdate3.current = false;
        }else{
            var elem = document.getElementById("PSSclock");
            var elem2 = document.getElementById("PSSclockdown");
            elem2.style.transition = "transform 0.5s"
            if(showClock===true){
                elem.className = "PSSpertanyaan flex PSSyellow";
                elem2.style.transform = "rotate(180deg)"
            }else{
                elem.className = "PSSpertanyaan flex";
                elem2.style.transform = "rotate(0)"
            }
        }
    },[showClock])

    useEffect(()=>{
        if (firstUpdate4.current) {
            firstUpdate4.current = false;
        }else{
            var elem = document.getElementById("PSSstyle");
            var elem2 = document.getElementById("PSSstyledown");
            elem2.style.transition = "transform 0.5s"
            if(showStyle===true){
                elem.className = "PSSpertanyaan flex PSSyellow";
                elem2.style.transform = "rotate(180deg)"
            }else{
                elem.className = "PSSpertanyaan flex";
                elem2.style.transform = "rotate(0)"
            }
        }
    },[showStyle])

    const handleOpenPopUp = (e) => {
        if(e === "date"){
            setShowClock(false)
            setShowStyle(false)
            setShowCalendar(true)
        }else if(e === "clock"){
            setShowClock(true)
            setShowStyle(false)
            setShowCalendar(false)
        }else{
            setShowClock(false)
            setShowStyle(true)
            setShowCalendar(false)
        }
    }

    const convertToRupiah = (angka) => {
        var rupiah = '';		
        var angkarev = angka.toString().split('').reverse().join('');
        for(var i = 0; i < angkarev.length; i++) if(i%3 === 0) rupiah += angkarev.substr(i,3)+'.';
        return rupiah.split('',rupiah.length-1).reverse().join('');
    }

    useEffect(()=>{
        if (firstUpdate5.current) {
            firstUpdate5.current = false;
        }else{
            for (var x in detail.pricelist){
                if(guest <= detail.pricelist[x].max && guest >= detail.pricelist[x].min){
                    setTotal(detail.pricelist[x].harga * 1000 * guest)
                }
            }
        }
    },[guest])

    const handleSubmit = () => {
        let isError=false
        var elem = document.getElementById("PSSdate");
        var elem2 = document.getElementById("PSSclock");
        var elem3 = document.getElementById("PSSstyle");
        if(dateShown === 'Select date'){
            elem.className = "PSSpertanyaan flex PSSred";
            isError=true
            setval1(true)
        }else{
            elem.className = "PSSpertanyaan flex";
            setval1(false)
        }if(clockSelected === 'Select time'){
            elem2.className = "PSSpertanyaan flex PSSred";
            isError=true
            setval2(true)
        }else{
            elem2.className = "PSSpertanyaan flex";
            setval2(false)
        }if(style==='Select serving style'){
            elem3.className = "PSSpertanyaan flex PSSred";
            isError=true
            setval3(true)
        }else{
            elem3.className = "PSSpertanyaan flex";
            setval3(false)
        }

        if(isError){
            return
        }else{
            setstandby(false)
            localStorage.setItem('tanggal',dateShown)
            localStorage.setItem('jam',clockSelected)
            localStorage.setItem('style', style)
            localStorage.setItem('specialRequest', specialRequest)
            localStorage.setItem('pax', guest)
            localStorage.setItem('total',total)
        }
    }

    const [standby, setstandby] = useState(true)
    useEffect(()=>{
        
        if(standby===false){
            setTimeout(function() {
                history('/category/chefList/detailChef/detailMenu/setSchedule/setVenue');
           }, 500);
        }
    },[standby])
    
    const parseAllMenuDetailPrice = (menuDetailPrice) => {
        menuDetailPrice = menuDetailPrice.map((el) => {
            return {
                chef_image_url: el.chef_image_url,
                chef_name: el.chef_name,
                image_url: el.image_url,
                name: el.name,
                menu_names: el.menu_names,
                contains: el.contains,
                pricings:el.pricings
            }
        })
        return menuDetailPrice[0]
    }

    const callApigetMenuDetailPrice = async (type) => {
        try {
            let params = null
            if (type) {
                params = { type }
            }
            const { data: res } = await axios({
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'get',
                url: `${baseUrl}event/anniversary-pik`,
                params
            })
            const menuDetailPrice = res.data
            const parsedMenuDetailPrice = parseAllMenuDetailPrice(menuDetailPrice)
            return parsedMenuDetailPrice
        } catch (error) {
            console.log("error getMenuDetailPriceFromDB")
            // Create error handler (pop-up or something)
        }
    }

    return (
        <div onClick={e => {e.stopPropagation();handleCloseAll()}} id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <img onClick={e => {e.preventDefault();e.stopPropagation();history(-1)}} className='backmobile' alt="back" src={circleback}></img>
            {
                loading?
                <img alt='loading' className='taplakLoading' src={spinner}></img>
                :
                <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="PSStrans">
                <div className='PSScontainer'>
                    <p className='PSStitle big bold white'>Set Schedule</p>
                    <div className='flex PSSmainwrapper'>
                        <div className='PSSkontenkiri'>
                            <p className='semibig white PSSmargin'>Your Chef</p>
                            <div className='flex' style={{marginTop:"18px"}}>
                                <div className='PSSimg' style={{backgroundImage:`url(${detail.foto})`}}></div>
                                <p className='PSSimg2 normal medium white'>{detail.chef}</p>
                            </div>

                            <p className="semibig white PSSmargin">Your Menu</p>
                            <div className='flex' style={{marginTop:"18px"}}>
                                <div className='PSSimg' style={{backgroundImage:`url(${detail.fotoMakanan})`}}></div>
                                <div className='PSSimg2 flex' style={{flexDirection:"column"}}>
                                    <p className='normal medium white'>{detail.jenis} Food</p>
                                    <p className='small white bold' style={{marginTop:"8px"}}>
                                        {
                                            detail.menu.map((post) => {
                                                if(post === detail.menu[0]){
                                                    return(<span>{post}</span>)

                                                }else{
                                                    return(<span>, {post}</span>)
                                                }
                                            })
                                        }
                                    </p>
                                </div>
                            </div>

                            <p className="semibig white PSSmargin">Special Request</p>
                            <p className="tiny" style={{color:"#AAAAAA", marginTop:"18px"}}>*Any requests made will be reviewed by the Taplak Partner before confirming the event</p>
                            <textarea onClick={e => {e.preventDefault();e.stopPropagation();handleCloseAll()}} value={specialRequest} onChange={e => setSpecialRequest(e.target.value)} className='PSStextarea' rows="10" placeholder="*Any requests made will be reviewed by the Taplak Partner before confirming the event"></textarea>
                        </div>
                        
                        <div className='PSSkontenkanan'>
                            <div className='PSSkananwrapper'>
                                <div className='PSSformkontainer'>
                                    <p className='medium bold'>Your Booking</p>
                                    <div className='PSSformgroup flex'>
                                        <div className='PSSpertanyaanflex' style={{marginRight:"10px"}}>
                                            <p className='small normal PSSpertanyaantext'>Date</p>
                                            <div onClick={e => {e.preventDefault();e.stopPropagation();showCalendar? setShowCalendar(false):handleOpenPopUp("date")}} id="PSSdate" className='PSSpertanyaan flex'>
                                                <img className='PSSiconkiri' alt='icon' src={calendar}></img>
                                                <p id="PSSdateshown" className='verytiny normal PSSpertanyaantext'>{dateShown}</p>
                                                <img id="PSSdatedown" className='PSSiconkanan' alt='icon' src={down}></img>
                                            </div>
                                        </div>
                                        {
                                        showCalendar === true && (
                                            <div className="PSSpopupkontainer" style={{ width: "48%" }}>
                                                <div style={{postion:"relative", height:"100%", width:"100%"}}>
                                                <DatePicker
                                                    id="dateStartEnd"
                                                    dateFormat="MM/dd/yyyy"
                                                    className={'form-control form-control-sm'}
                                                    autoFocus={true}
                                                    shouldCloseOnSelect={false}
                                                    selected={selectedDate}
                                                    onChange={(date) => handleSelectDate(date)}
                                                    monthsShown={1}
                                                    inline
                                                    minDate={new Date()}

                                                    style={{width:"100%"}}
                                                />
                                                </div>
                                            </div>
                                        )
                                        }
                                        {
                                            showClock === true && (
                                                <div className="PSSpopupkontainer" style={{right:"0", width:"48%"}}>
                                                    <div style={{postion:"relative", height:"100%", width:"max-content", padding:"25px"}}>
                                                    {
                                                        detail.jam.map((post) => (
                                                            <p onClick={e => {e.preventDefault();e.stopPropagation();handleClockSelect(post)}}>{post}</p>
                                                        ))
                                                    }
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className='PSSpertanyaanflex' style={{marginLeft:"10px"}}>
                                            <p className='small normal PSSpertanyaantext'>Time</p>
                                            <div onClick={e => {e.preventDefault();e.stopPropagation();showClock? setShowClock(false):handleOpenPopUp("clock")}} id="PSSclock" className='PSSpertanyaan flex'>
                                                <img className='PSSiconkiri' alt='icon' src={time}></img>
                                                <p id="PSSclockshown" className='verytiny normal PSSpertanyaantext'>{clockSelected}</p>
                                                <img id="PSSclockdown" className='PSSiconkanan' alt='icon' src={down}></img>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        val1 && (
                                            <p className='bold verytiny' style={{color:"#FA591D", marginTop:"8px", marginBottom:"8px", textAlign:"right"}}>Please select the date!</p>
                                        )
                                    }

                                    {
                                        val2 && (
                                            <p className='bold verytiny' style={{color:"#FA591D", marginTop:"8px", marginBottom:"8px", textAlign:"right"}}>Please select the time!</p>
                                        )
                                    }

                                    <div className='PSSformgroup'>
                                        <div className='PSSpertanyaanflex'>
                                            <p className='small normal PSSpertanyaantext'>Serving style</p>
                                            <div onClick={e => {e.preventDefault();e.stopPropagation();showStyle? setShowStyle(false):handleOpenPopUp("style")}} id="PSSstyle" className='PSSpertanyaan flex'>
                                                <img className='PSSiconkiri' alt='icon' src={user}></img>
                                                <p id="PSSstyleshown" className='verytiny normal PSSpertanyaantext'>{style}</p>
                                                <img id="PSSstyledown" className='PSSiconkanan' alt='icon' src={down}></img>
                                            </div>
                                        </div>
                                        {
                                            showStyle === true && (
                                                <div className="PSSpopupkontainer" style={{right:"0", width:"100%", marginTop:"10px"}}>
                                                    <div style={{postion:"relative", height:"100%", width:"auto", padding:"25px"}}>
                                                        <div onClick={e => {e.preventDefault();e.stopPropagation();handleSelectStyle('Individual Plating')}} style={{marginBottom:"24px"}}>
                                                            <p className='tiny bold' style={{marginBottom:"8px"}}>Individual Plating</p>
                                                            <p className='verytiny normal'>Plating individual dish to every person</p>
                                                        </div>
                                                        <div onClick={e => {e.preventDefault();e.stopPropagation();handleSelectStyle('Family-Style')}} style={{marginBottom:"24px"}}>
                                                            <p className='tiny bold' style={{marginBottom:"8px"}}>Family-Style</p>
                                                            <p className='verytiny normal'>Dish is served on large platters meant for sharing, reather as individual plates, and being placed on the center of the table</p>
                                                        </div>
                                                        <div onClick={e => {e.preventDefault();e.stopPropagation();handleSelectStyle('Standart Buffet Style')}}>
                                                            <p className='tiny bold' style={{marginBottom:"8px"}}>Standart Buffet Style</p>
                                                            <p className='verytiny normal'>A self-service style where Penyantap serve themselves</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>

                                    {
                                        val3 && (
                                            <p className='bold verytiny' style={{color:"#FA591D", marginTop:"8px", marginBottom:"8px", textAlign:"right"}}>Please select the style!</p>
                                        )
                                    }

                                    <div className='PSSformgroup'>
                                        <div className='PSSpertanyaanflex'>
                                            <p className='small normal PSSpertanyaantext'>Guest</p>
                                            <div className='PSSpertanyaan flex'>
                                                <img className='PSSiconkiri' alt='icon' src={user}></img>
                                                <p id="PSSguestshown" className='verytiny normal PSSpertanyaantext'>{guest} guest</p>
                                                <img onClick={e => {e.preventDefault();e.stopPropagation();handleCloseAll();handleGuest("minus")}} className='PSSiconkanan' alt='icon' src={minus}></img>
                                                <img onClick={e => {e.preventDefault();e.stopPropagation();handleCloseAll();handleGuest("plus")}} className='PSSiconkanan' alt='icon' style={{marginLeft:"24px"}} src={plus}></img>
                                            </div>
                                        </div>
                                    </div>

                                    <p className='PSSpertanyaantext tiny normal' style={{marginTop:"16px"}}>Set menu price(s)</p>
                                    
                                        {
                                            detail.pricelist.map((post) => (
                                                <div className='flex' style={{marginTop:"8px"}}>
                                                    <p className='PSSpertanyaantext tiny bold'>{post.min} - {post.max} guest</p>
                                                    <p className='PSSpertanyaantext tiny bold' style={{marginLeft:"auto"}}>{post.harga}/Pax</p>
                                                </div>
                                            ))
                                        }
                                    <div className='flex' style={{marginTop:"32px"}}>
                                        <p className='bold medium'>Total</p>
                                        <p className='bold medium' style={{marginLeft:"auto"}}>IDR {convertToRupiah(total)}</p>
                                    </div>
                                    
                                </div>
                                {
                                    localStorage.getItem('TaplakLoggedIn')==='true' ?

                                <div className='PSSformkontainer' style={{marginTop:"32px"}}>
                                    <p className='medium bold'>Set Venue</p>
                                    <button onClick={e => {e.preventDefault();e.stopPropagation();handleSubmit()}}  className='PSSbutton bold'>Continue to set venue</button>
                                </div>
                                :
                                <div className='PSSformkontainer' style={{marginTop:"32px"}}>
                                    <p className='medium bold'>Login or register to book</p>
                                    <button onClick={e => {e.preventDefault();e.stopPropagation();setShowLogin(true)}} className='PSSbutton bold'>Login/Register</button>
                                </div>
                                }
                            </div>
                            

                            
                        </div>
                    </div>
                </div>
                </CSSTransition>
            }
            {
                showLogin && (
                <PageLogin fungsi={() => setShowLogin(false)}></PageLogin>
                )
            }
            
        </div>
    )
  }